// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root___R6CH","footer":"ModalUpdate_footer__3xGmY"};